import { takeLeading } from 'redux-saga/effects';
import { GET_RESEARCH_TEMPLATES } from './types';
import { getResearchTemplates } from './sagas/getResearchTemplates';

function* getResearchTemplatesWatcher() {
	yield takeLeading(GET_RESEARCH_TEMPLATES, getResearchTemplates);
}

export const researchTemplatesWatchers = [getResearchTemplatesWatcher];
